import httpClient from '@/global/httpClient';
import qs from 'qs';

import * as apis from '@/constants/api';

export const checkExistNickname = (payload) =>
  httpClient.post(apis.CHECK_EXIST_NICKNAME, qs.stringify(payload), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    ignoreLoading: true,
    ignore: true,
  });
export const getMallCountries = () =>
  httpClient.get(apis.GET_MALL_COUNTRIES, { ignore: true, ignoreLoading: true });
export const validateEmail = (email) =>
  httpClient.get(apis.VALIDATE_EMAIL, {
    params: { value: email },
    ignore: true,
  });
export const prepurchaseFromWechat = (payload) =>
  httpClient.post(apis.PREPURCHAGE_FROM_WECHAT, payload, { ignore: true });
export const prepurchaseFromEmail = (payload) =>
  httpClient.post(apis.PREPURCHAGE_FROM_EMAIL, payload, { ignore: true });

//
export const getWechatQrcode = () =>
  httpClient.get(apis.GET_WECHAT_QRCODE, {
    ignore: true,
    ignoreLoading: true,
  });
